import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "body"
}
const _hoisted_3 = { key: 1 }

import { useSlots } from 'vue'
import IconUI from './IconUI.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationUI',
  props: {
  type: { type: String, default: 'error' },
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  iconName: { type: String, default: 'danger' },
  iconFill: { type: String, default: 'white' },
},
  setup(__props) {



const slots = useSlots()
const hasSlotData = () => !!slots.default

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notification", __props.type])
  }, [
    (__props.title.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.iconName.length)
            ? (_openBlock(), _createBlock(IconUI, {
                key: 0,
                name: __props.iconName,
                fill: __props.iconFill,
                title: __props.iconName
              }, null, 8, ["name", "fill", "title"]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(__props.title), 1)
        ]))
      : _createCommentVNode("", true),
    (hasSlotData() || __props.message.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.iconName.length && !__props.title.length)
            ? (_openBlock(), _createBlock(IconUI, {
                key: 0,
                name: __props.iconName,
                fill: __props.iconFill,
                title: __props.iconName
              }, null, 8, ["name", "fill", "title"]))
            : _createCommentVNode("", true),
          (__props.message.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.message), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})